import { env, EnvVars } from "@/utils/env";

const theme = {
    cna: {
        companyName: 'CNA',
        secondName: 'SpazioCNA',
        footerName: 'Spazio CNA',
        companySite: 'spaziocna.it',
        whatsappName: 'CNA',
        whatsappURL: 'https://wa.me/message/72UWJHSQ7F2ME1',
        mail: 'info@cnasostenibile.it',
        logo: require('@/assets/images/cna/logo.svg'),
        logoWhite: require('@/assets/images/cna/logo_text_white.svg'),
        logoBlue: require('@/assets/images/cna/logo_text_blu.svg'),
        logoCCIAA: require('@/assets/images/cna/logo_CCIAA.png'),
        logoCCIAAWhite: require('@/assets/images/cna/logo_CCIAA_white.png'),
        logoLoginWidth: 'w-20',
        colors: {
            primary: '#134B85',
            secondary: '#404040',
            accent: '#16BFFF',
            error:'#C71F27',
            success:'#38A751',
            warning: '#EF6C00',
        }
    },
    megamark: {
        companyName: 'WH',
        secondName: 'WH',
        footerName: 'Whp',
        companySite: 'whp.ai',
        whatsappName: 'Megamark',
        whatsappURL: '#',
        mail: 'info@whp.ai',
        logo: require('@/assets/images/lms/whead-logo.svg'),
        logoLoginWidth: 'w-20',
        colors: {
            primary: '#142537',
            secondary: '#0f172b',
            accent: '#B5DD10',
            error:'#C71F27',
            success:'#38A751',
            warning: '#EF6C00',
        }
    },
    gsgconsulting: {
        companyName: 'GSG',
        secondName: 'GSG Consulting',
        footerName: 'GSG Consulting',
        companySite: 'whp.ai',
        whatsappName: 'GSG Consulting',
        whatsappURL: '#',
        mail: 'info@gsgconsulting.it',
        logo: require('@/assets/images/gsg/gsg-logo.png'),
        logoWhite: require('@/assets/images/gsg/gsg-logo-white.png'),
        logoLoginWidth: 'w-40',
        colors: {
            primary: '#142537',
            secondary: '#0f172b',
            accent: '#B5DD10',
            error:'#C71F27',
            success:'#38A751',
            warning: '#EF6C00',
        }
    },
}

export default theme[env()[EnvVars.VUE_APP_COMPANY]]
